import {
  schoolAllSecurityRules,
  deletePushRule,
  getDeptDetail,
} from '../../../../../services/studentAttendance/pushReportManage';

const initState = {
  attendanceObjectVisible: false,
  deptDetailData: [],
  deptDetailTotalNumber: 0,
};

export default {
  namespace: 'pushReportManage',
  state: initState,
  effects: {
    *fetchSchoolAllSecurityRules({ params }, { call }) {
      try {
        const response = yield call(schoolAllSecurityRules, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
    *fetchDeletePushRule({ params }, { call }) {
      try {
        const response = yield call(deletePushRule, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
    *fetchDeptDetail({ params }, { call, put }) {
      try {
        const response = yield call(getDeptDetail, params);
        yield put({
          type: 'saveState',
          payload: {
            attendanceObjectVisible: true,
            deptDetailData: response.classDetailNumberList,
            deptDetailTotalNumber: response.totalNumber,
          },
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
